import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { isInAbilityCircle, isInAbilityCone, isWithinAbilityRange, scaleLolDistance } from '../combat/abilityArea.js';

export const DARIUS_HEMORRHAGE_MAX_STACKS = 5;
export const DARIUS_NOXIAN_MIGHT_BONUS_AD = 40;

export function createDarius(id = 'darius-1', team = 'blue', x = 300, y = 1300) {
  const darius = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 600,
    maxMp: 0,
    ad: 66,
    ap: 0,
    armor: 41,
    mr: 32,
    ms: 340,
    attackRange: 175,
    attackSpeed: 0.625,
    name: 'Darius',
    radius: 22
  });
  darius.wEmpowered = false;
  darius.hemorrhageStacks = 0;
  darius.noxianMightActive = false;
  return darius;
}

/** Hemorrhage: stack on hit; bleed; Noxian Might at max stacks. */
export function applyDariusHemorrhage(darius, target) {
  if (!darius || darius.isDead || !target || target.isDead) return false;
  if (target.team === darius.team) return false;
  const next = Math.min(
    DARIUS_HEMORRHAGE_MAX_STACKS,
    (target.hemorrhageStacks || 0) + 1
  );
  target.hemorrhageStacks = next;
  darius.hemorrhageStacks = next;
  const bleed = 4 + darius.ad * 0.04 * next;
  target.takeDamage(bleed, darius, 'physical');
  if (next >= DARIUS_HEMORRHAGE_MAX_STACKS && !darius.noxianMightActive) {
    darius.noxianMightActive = true;
    darius.ad += DARIUS_NOXIAN_MIGHT_BONUS_AD;
  }
  return true;
}

export function castDariusQ(caster, entities = []) {
  if (!caster || caster.isDead) return false;
  let hit = false;
  const damage = 45 + caster.ad * 0.5;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, caster.x, caster.y, 460, caster)) continue;
    e.takeDamage(damage, caster, 'physical');
    applyDariusHemorrhage(caster, e);
    hit = true;
  }
  if (hit) caster.hp = Math.min(caster.maxHp, caster.hp + 35 + caster.ad * 0.2);
  return true;
}

export function castDariusW(caster) {
  if (!caster || caster.isDead) return false;
  caster.wEmpowered = true;
  return true;
}

export function castDariusE(caster, targetX, targetY, entities = []) {
  if (!caster || caster.isDead) return false;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const pull = scaleLolDistance(120, caster);
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCone(e, caster.x, caster.y, angle, 535, 0.436, caster)) continue;
    e.x = caster.x + Math.cos(angle) * pull;
    e.y = caster.y + Math.sin(angle) * pull;
    if (Number.isFinite(e.z)) e.z = e.y;
    e.statusManager?.addEffect?.(EFFECT_TYPES.SLOW, 1.0, 0.4);
    applyDariusHemorrhage(caster, e);
  }
  return true;
}

export function castDariusR(caster, target) {
  if (!caster || caster.isDead || !target || target.isDead) return false;
  if (!isWithinAbilityRange(caster, target, 475, caster)) return false;
  const missing = target.maxHp - target.hp;
  const trueDamage = 100 + missing * 0.2 + caster.ad * 0.75;
  target.takeDamage(trueDamage, caster, 'true');
  applyDariusHemorrhage(caster, target);
  return true;
}
